import { onUnmounted } from 'vue-demi';
import { HotkeyManager } from './HotkeyManager';
const manager = new HotkeyManager();
/**
 * Register hotkeys.
 * Hotkeys are automatically removed when the component gets unmounted.
 *
 * @param hotkeys Hotkeys to register.
 */
export function useHotkey(hotkeys) {
    hotkeys.forEach(hk => manager.registerHotkey(hk));
    onUnmounted(() => hotkeys.forEach(hk => manager.removeHotkey(hk)));
}
